document.addEventListener('DOMContentLoaded', function () {
  const tocList = document.getElementById('table-of-contents-list');

  if (!tocList) return;
  
  // Check if this table of contents has already been processed
  if (tocList.dataset.processed === 'true') return;
  
  // Mark as processed to prevent duplicate processing
  tocList.dataset.processed = 'true';
  
  // Clear any existing content
  tocList.innerHTML = '';

  // Get the table of contents section to exclude its own headings
  const tocSection = tocList.closest('.table-of-contents');

  // Find all H2 headings on the entire page, excluding footer and table of contents section
  const headings = Array.from(document.querySelectorAll('h2')).filter(heading => {
    // Exclude footer headings
    if (heading.closest('footer')) return false;
    
    // Exclude headings within the table of contents section itself
    if (tocSection && tocSection.contains(heading)) return false;
    
    // Exclude headings within collection hero description
    if (heading.closest('.collection-hero__description')) return false;
    
    // Exclude cart-related headings (cart totals, notifications, etc.)
    const headingText = heading.textContent.trim().toLowerCase();
    const cartKeywords = ['cart', 'warenkorb', 'added', 'gelegt', 'notification', 'estimated', 'gesamtkosten', 'total', 'rabattcode', 'promocode', 'coupon', 'kundengruppe*', 'kundengruppe', 'cookie-zustimmung', 'cookie'];
    if (cartKeywords.some(keyword => headingText.includes(keyword))) return false;
    
    // Exclude headings with cart-related classes
    if (heading.classList.contains('totals__total')) return false;
    
    return true;
  });

  if (headings.length === 0) {
    // Hide the section if no headings found
    tocList.closest('.table-of-contents').style.display = 'none';
    return;
  }

  // Generate table of contents
  let validIndex = 0;
  headings.forEach((heading, index) => {
    // Skip empty headings
    if (!heading.textContent.trim()) {
      return;
    }

    // Create ID for the heading if it doesn't have one
    if (!heading.id) {
      heading.id = 'heading-' + (validIndex + 1);
    }

    // Create list item
    const listItem = document.createElement('li');
    listItem.className = 'table-of-contents__item';

    // Create link
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.className = 'table-of-contents__link';
    link.textContent = heading.textContent.trim();

    // Add number
    const number = document.createElement('span');
    number.className = 'table-of-contents__number';
    number.textContent = validIndex + 1 + '.';

    // Assemble the link
    link.insertBefore(number, link.firstChild);
    listItem.appendChild(link);
    tocList.appendChild(listItem);
    
    validIndex++;
  });

  // Smooth scrolling for anchor links
  tocList.addEventListener('click', function (e) {
    if (e.target.classList.contains('table-of-contents__link')) {
      e.preventDefault();
      const targetId = e.target.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const headerOffset = 200; // Adjust this value based on your header height
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  });

  // Highlight active section on scroll
  function highlightActiveSection() {
    const headings = Array.from(document.querySelectorAll('h2')).filter(heading => {
      // Use the same filtering logic as above
      if (heading.closest('footer')) return false;
      if (tocSection && tocSection.contains(heading)) return false;
      
      // Exclude headings within collection hero description
      if (heading.closest('.collection-hero__description')) return false;
      
      const headingText = heading.textContent.trim().toLowerCase();
      const cartKeywords = ['cart', 'warenkorb', 'added', 'gelegt', 'notification', 'estimated', 'gesamtkosten', 'total'];
      if (cartKeywords.some(keyword => headingText.includes(keyword))) return false;
      
      // Exclude headings with cart-related classes
      if (heading.classList.contains('totals__total')) return false;
      
      return true;
    });
    const tocLinks = Array.from(tocList.querySelectorAll('.table-of-contents__link'));

    // Remove active class from all links
    tocLinks.forEach((link) => link.classList.remove('active'));

    // Find the current active heading
    let activeHeading = null;
    const headerOffset = 200; // Adjust this value based on your header height
    const scrollPosition = window.scrollY + headerOffset; // Add header offset for better detection

    for (let i = headings.length - 1; i >= 0; i--) {
      const heading = headings[i];
      const headingTop = heading.offsetTop;

      if (scrollPosition >= headingTop) {
        activeHeading = heading;
        break;
      }
    }

    // Add active class to corresponding link
    if (activeHeading) {
      const activeLink = tocLinks.find((link) => link.getAttribute('href') === '#' + activeHeading.id);
      if (activeLink) {
        activeLink.classList.add('active');
      }
    }
  }

  // Add scroll event listener
  window.addEventListener('scroll', highlightActiveSection);

  // Initial call to set active section
  highlightActiveSection();
}); 